import React from 'react';
import { useNavigate } from 'react-router-dom';
import eImg from '../../../img/coves1.jpeg';
import jImg from '../../../img/coves2.jpeg';
import lImg from '../../../img/coves3.jpeg';

const ProductsCoves = () => {
  const navigate = useNavigate();

  const covesProducts = [
    {
      moldingNumber: "C001",
      description: "Moldura de cove elegante con una curva suave, ideal para interiores clásicos.",
      images: [eImg]
    },
    {
      moldingNumber: "C002",
      description: "Moldura de cove simple y moderna, perfecta para diseños contemporáneos.",
      images: [jImg]
    },
    {
      moldingNumber: "C003",
      description: "Moldura de cove decorativa con detalles intrincados para espacios únicos.",
      images: [lImg]
    },
  ];

  const handleContactClick = () => {
    navigate('/es/contact');
  };

  return (
    <div className="container mx-auto px-4 py-20">
      <h1 className="text-3xl font-bold text-center mb-8 font-montserrat">
        Colección de Molduras de Cove
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {covesProducts.map((product) => (
          <div
            className="bg-white rounded-lg shadow-md overflow-hidden transform transition-transform duration-300 hover:scale-105 cursor-pointer flex flex-col h-full"
            key={product.moldingNumber}
          >
            <div className="w-full h-48">
              {product.images.map((image, index) => (
                <img
                  src={image}
                  alt={`Moldura de cove ${product.moldingNumber}`}
                  className="w-full h-full object-cover"
                  key={index}
                />
              ))}
            </div>

            <div className="p-4 flex flex-col flex-grow">
              <h5 className="text-xl font-semibold text-gray-800 mb-2">
                Moldura de Cove {product.moldingNumber}
              </h5>
              <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                {product.description}
              </p>
            </div>
          </div>
        ))}

        <div
          className="md:col-span-2 bg-emerald-800 rounded-lg shadow-md p-6 flex flex-col justify-between cursor-pointer hover:bg-emerald-700 transition-colors duration-300"
          onClick={handleContactClick}
        >
          <div>
            <h5 className="text-xl font-bold text-emerald-50 mb-4">¿Necesitas más información?</h5>
            <p className="text-emerald-100 mb-4">
              ¿Estás interesado en nuestras molduras de cove? ¿Quieres discutir diseños personalizados o recibir una cotización? 
              Nuestro equipo está listo para ayudarte a encontrar la moldura perfecta para tu proyecto.
            </p>
            <p className="text-emerald-100">
              Para ver la lista completa de productos, por favor regístrate para obtener tu token de acceso (clave).
            </p>
          </div>
          <div className="mt-4">
            <span className="text-emerald-50 font-semibold hover:underline">
              Contáctanos →
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsCoves;
